import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=3df8533d&"
import script from "./BottomNavigation.vue?vue&type=script&lang=js&"
export * from "./BottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=3df8533d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports